import { Component, OnInit } from '@angular/core';
import { values } from 'lodash';
import { EaGroup } from '../../ea-group/ea-group.component';
import { EaGridkyService } from '../ea-gridky.service';

@Component({
    selector: 'ea-gridky-details',
    templateUrl: './ea-gridky-details.component.html',
    styleUrls: ['./ea-gridky-details.component.scss'],
    standalone: false
})
export class EaGridkyDetailsComponent implements OnInit {
  constructor(private eaGridkyService: EaGridkyService) {}

  group = new EaGroup(
    'Détails utiles',
    [
      {
        label: 'Type de bien',
        value: () => this.eaGridkyService.getProductType(),
        icon: 'sp-sign',
      },
      {
        label: 'Dimension du bien ',
        value: () => `${Math.round(this.eaGridkyService.product.surface)} m²`,
        icon: 'sp-maximize',
      },
      {
        label: 'Etage',
        value: () =>
          this.eaGridkyService.product.floor
            ? this.eaGridkyService.product.floor
            : 'Rez-de-chaussée',
        icon: 'sp-stair',
      },
      {
        label: 'Orientation',
        value: () => this.eaGridkyService.getProductOrientation(),
        icon: 'sp-compass',
      },
      {
        label: 'Ville / Département ',
        value: () =>
          `${this.eaGridkyService.product.program.city} / ${this.eaGridkyService.product.program.cityData?.departmentName || 'N/C'}`,
        icon: 'sp-crosshair',
      },
    ],
    () => false,
  );

  ngOnInit() {}
}
